import * as React from 'react';
import { message, Modal } from 'antd';
import { Moment } from 'moment';
import { StylesProps } from '../../theme/jss-types';
import { CreateActions } from './create-modal.constants';
import successIcon from '../../assets/consignment-success.png';
import withStyles from 'react-jss';
import ConsignmentsIcon from '../../assets/consignments';
import {
    ExclamationCircleFilled,
    PlusOutlined,
    PrinterOutlined,
} from '@ant-design/icons';
import Helper from 'library/Helper';
import { printInvoice } from 'network/consignments.api';
import InvoiceIcon from 'assets/invoice';
import { useTranslation } from 'react-i18next';
import { ZIndex } from 'library/constants';
import useIsMobile from 'hooks/useIsMobile';

const styles = {
    modal: {
        '& .ant-modal-content': {
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
        },
        '& .ant-modal-body': {
            padding: 0,
        },
    },
    row: {
        display: 'flex',
        marginBottom: 7,
        padding: '24px 24px 0px 24px',
    },
    col: {
        display: 'flex',
        flexDirection: 'column',
    },
    addedTitle: {
        color: '#111111',
        fontSize: 16,
        fontWeight: 'bold',
    },
    addedMsg: {
        color: '#666666',
        fontSize: 12,
        width: '65%',
        marginTop: 4,
        marginBottom: 8,
    },
    img: {
        marginRight: 16,
        height: 64,
        width: 64,
        marginTop: 6,
    },
    dateTime: {
        color: '#666666',
        fontSize: 10,
        fontWeight: 600,
        marginTop: 4,
    },
    actions: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 4,
        padding: '17px 0px 17px 24px',
        backgroundColor: '#FCFCFC',
    },
    actionItem: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#111111',
        fontSize: 12,
        marginRight: 24,
        cursor: 'pointer',
        fontWeight: 600,
    },
    failureRow: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        color: '#EA2626',
        fontSize: 12,
        fontWeight: 600,
    },
    viewErr: {
        fontSize: 12,
        color: '#111111',
        textDecoration: 'underline',
        fontWeight: 600,
    },
    icon: {
        marginRight: 8,
    },
    content: {
        borderRadius: 4,
        border: '1px solid #F7F7F7',
        boxShadow: '2px 2px 4px 0 rgba(0,0,0,0.1)',
    },
    falure: {
        backgroundColor: '#FFF3EE',
        padding: '12px 24px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    modalMobile: {
        alignItems: 'center',
        justifyContent: 'center',
        '& .ant-modal-content': {
            borderRadius: 4,
            backgroundColor: '#FFFFFF',
        },
        '& .ant-modal-body': {
            padding: 0,
        },
    },
    rowMobile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        marginBottom: 7,
        padding: '24px 24px 0px 24px',
    },
    colMobile: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    imgMobile: {
        marginRight: 0,
        marginBottom: 16,
        height: 64,
        width: 64,
        marginTop: 6,
    },
    addedMsgMobile: {
        color: '#666666',
        fontSize: 12,
        width: '90%',
        marginTop: 4,
        marginBottom: 8,
    },
    actionsMobile: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-around',
        borderRadius: 4,
        padding: '12px',
        backgroundColor: '#FCFCFC',
    },
    actionItemMobile: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#111111',
        fontSize: 12,
        marginRight: 0,
        cursor: 'pointer',
        fontWeight: 600,
        flex: 1,
    },
};

interface IProps extends StylesProps<typeof styles> {
    action: CreateActions;
    data: any;
    creationTime: Moment;
    handleAction: (actionType: string) => void;
    successArray?: any[];
    failureArray?: any[];
    showSupplementaryServices: boolean;
}
const SuccessProtip = (props: IProps) => {
    const {
        classes,
        action,
        data,
        handleAction,
        successArray,
        failureArray,
        creationTime,
        showSupplementaryServices,
    } = props;

    const { t, i18n } = useTranslation();
    const isMobile = useIsMobile();

    const renderSingleAdded = () => {
        if (action !== CreateActions.SingleConsignment) {
            return null;
        }
        return (
            <span className={isMobile ? classes.addedMsgMobile : classes.addedMsg}>
                Your consignment with CN Reference No. &nbsp;
                {`${data?.referenceNumber}  is successfully Created.`}
            </span>
        );
    };

    const renderTitle = () => {
        const len = successArray?.length;
        return (
            <span className={classes.addedTitle}>
                {`${len || ''} `}
                {i18n.exists('consignment_success')
                    ? t('consignment_success')
                    : 'Consignment Added Successfully!'}
            </span>
        );
    };

    const renderDateTime = () => {
        return (
            <span className={classes.dateTime}>
                {creationTime}
            </span>
        );
    };

    const renderMessage = () => {
        return (
            <div className={isMobile ? classes.colMobile : classes.col}>
                {renderTitle()}
                {renderSingleAdded()}
                {renderDateTime()}
            </div>
        );
    };

    const renderImg = () => {
        return (
            <img
                alt="success"
                src={successIcon}
                className={isMobile ? classes.imgMobile : classes.img}
            />
        );
    };

    const renderDetails = () => {
        return (
            <div className={isMobile ? classes.rowMobile : classes.row}>
                {renderImg()}
                {renderMessage()}
            </div>
        );
    };

    const renderPrint = () => {
        if (action !== CreateActions.SingleConsignment) {
            return null;
        }
        return (
            <span
                className={isMobile ? classes.actionItemMobile : classes.actionItem}
                onClick={() => handleAction('print')}
            >
                <PrinterOutlined className={classes.icon} />
                {i18n.exists('print_label') ? t('print_label') : 'Print Label'}
            </span>
        );
    };

    const renderView = () => {
        return (
            <span
                className={isMobile ? classes.actionItemMobile : classes.actionItem}
                onClick={() => handleAction('view')}
            >
                <ConsignmentsIcon />
                <span style={{ marginLeft: 8 }}>
                    {i18n.exists('view_consignments') ? t('view_consignments') : 'View Consignments'}
                </span>
            </span>
        );
    };

    const renderAddMore = () => {
        return (
            <span
                className={isMobile ? classes.actionItemMobile : classes.actionItem}
                onClick={() => handleAction('addMore')}
            >
                <PlusOutlined className={classes.icon} />
                <span>
                    {i18n.exists('add_more_consignment') ? t('add_more_consignment') : 'Add More Consignment'}
                </span>
            </span>
        );
    };

    const handlePrintInvoice = async (referenceNumbers: any, fileName: string) => {
        const fileBuffer = await printInvoice({
            referenceNumbers,
        });
        if (fileBuffer.isSuccess) {
            const name = fileBuffer.filename || fileName;
            Helper.downloadFileData(
                fileBuffer.data,
                name,
                true,
                'pdf',
            );
            message.success('Success');
        } else {
            message.error('Failed to generate PDF!');
        }
    };

    const renderPrintInvoice = () => {
        if (!data?.showInvoicePrint) return null;
        return (
            <span
                className={isMobile ? classes.actionItemMobile : classes.actionItem}
                onClick={() => handlePrintInvoice(
                    [data?.referenceNumber],
                    `Invoice_${data?.referenceNumber}.pdf`,
                )}
            >
                <InvoiceIcon className={classes.icon} />
                <span>{i18n.exists('print_invoice') ? t('print_invoice') : 'Print Invoice'}</span>
            </span>
        );
    };

    const renderAddSuppServices = () => {
        if (!showSupplementaryServices) return null;
        return (
            <span
                className={isMobile ? classes.actionItemMobile : classes.actionItem}
                onClick={() => handleAction('addSuppServices')}
            >
                <PlusOutlined className={classes.icon} />
                <span> Add Supplementary Services </span>
            </span>
        );
    };

    const renderActions = () => {
        if (isMobile) {
            return (
                <div className={classes.actionsMobile}>
                    {renderPrint()}
                    {renderAddMore()}
                </div>
            );
        }
        return (
            <div className={classes.actions}>
                {renderPrint()}
                {renderView()}
                {renderAddMore()}
                {renderAddSuppServices()}
                {renderPrintInvoice()}
            </div>
        );
    };

    const inComplete = () => {
        return (
            <ExclamationCircleFilled
                className={classes.icon}
            />
        );
    };

    const renderFailure = () => {
        const len = failureArray?.length;
        if (!len) {
            return null;
        }
        return (
            <div className={classes.falure}>
                <span className={classes.failureRow}>
                    {inComplete()}
                    {`${len} Consignment failed in uploading.`}
                </span>
                <span className={classes.viewErr}>
                    View Error
                </span>
            </div>
        );
    };

    const renderContent = () => {
        return (
            <div className={classes.content}>
                {renderDetails()}
                {renderActions()}
                {renderFailure()}
            </div>
        );
    };

    return (
        <Modal
            visible
            zIndex={606}
            width={isMobile ? '100%' : '40%'}
            title={null}
            footer={null}
            maskClosable
            onCancel={() => handleAction('close')}
            className={isMobile ? classes.modalMobile : classes.modal}
            maskStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.25)',
                zIndex: ZIndex.forms,
            }}
        >
            {renderContent()}
        </Modal>
    );
};

export default withStyles(styles)(SuccessProtip);
